export default "__VITE_ASSET__Bz2w3oVx__"